import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment caseStudiesDefaultSummary on Craft_caseStudies_default_Entry {
    title
    uri
    uid
    sectionHandle
    caseStudyState
    caseStudyCategories {
      uid
      title
      slug
    }
    caseStudyProgramsAndProducts {
      uid
      title
      slug
    }
    excerpt

    authorProfile {
      ...profileEntrySummary
    }

    sponsor {
      ...sponsorEntry
    }

    coverPicture {
      ...mainFileUploadsAsset
    }
  }

  fragment caseStudiesDefaultEntry on Craft_caseStudies_default_Entry {
    ...caseStudiesDefaultSummary
    contentBlocks {
      ...audienceCardsContentBlockType
      ...buttonsContentBlockType
      ...cardsBlockType
      ...ctaContentBlockType
      ...embeddedCodeBlockType
      ...faqListContentBlockType
      ...faqListContentBlockType
      ...featuredCardContentBlockType
      ...featuredCaseStudiesBlockType
      ...featuredEventsContentBlockType
      ...featuredResourcesBlockType
      ...fullImageContentBlockType
      ...iconBarContentBlockType
      ...latestResourcesBlockType
      ...profileListContentBlockType
      ...pullQuoteContentBlockType
      ...richContentContentBlockType
      ...sectionHeaderContentBlockType
      ...sponsorListContentBlockType
      ...statsContentBlockType
      ...testimonialListContentBlockType
      ...upcomingEventsContentBlockType
      ...videoContentBlockType
    }

    seomatic {
      ...entrySEO
    }
  }
`

export const caseStudiesDefaultEntry = gql`
  fragment caseStudiesDefaultSummary on caseStudies_default_Entry {
    title
    uri
    uid
    sectionHandle
    caseStudyState
    caseStudyCategories {
      uid
      title
      slug
    }
    caseStudyProgramsAndProducts {
      uid
      title
      slug
    }
    excerpt

    authorProfile {
      ...profileEntrySummary
    }

    sponsor {
      ...sponsorEntry
    }

    coverPicture {
      ...mainFileUploadsAsset
    }
  }

  fragment caseStudiesDefaultEntry on caseStudies_default_Entry {
    ...caseStudiesDefaultSummary
    contentBlocks {
      ...audienceCardsContentBlockType
      ...buttonsContentBlockType
      ...cardsBlockType
      ...ctaContentBlockType
      ...embeddedCodeBlockType
      ...faqListContentBlockType
      ...faqListContentBlockType
      ...featuredCardContentBlockType
      ...featuredCaseStudiesBlockType
      ...featuredEventsContentBlockType
      ...featuredResourcesBlockType
      ...fullImageContentBlockType
      ...iconBarContentBlockType
      ...latestResourcesBlockType
      ...profileListContentBlockType
      ...pullQuoteContentBlockType
      ...richContentContentBlockType
      ...sectionHeaderContentBlockType
      ...sponsorListContentBlockType
      ...statsContentBlockType
      ...testimonialListContentBlockType
      ...upcomingEventsContentBlockType
      ...videoContentBlockType
    }

    seomatic {
      ...entrySEO
    }
  }
`
